import { ProjectMark, linkIcon, External } from './icons'
import { Reveal } from '../hooks/useReveal'

const ProjectCard = ({ project }) => (
  <article className="card" style={{ '--card-accent': `var(--p-${project.id})` }}>
    <div className="card__top">
      <span className="card__mark">
        <ProjectMark name={project.mark} />
      </span>
      <p className="card__kind">
        <b>{project.kind}</b>
        {project.year}
      </p>
    </div>

    <div className="card__body">
      <h3 className="card__name">{project.name}</h3>
      <p className="card__tagline">{project.tagline}</p>
      <p className="card__desc">{project.description}</p>
    </div>

    {project.note && <p className="card__note">{project.note}</p>}

    <ul className="card__tags">
      {project.tags.map((tag) => (
        <li className="chip" key={tag}>
          {tag}
        </li>
      ))}
    </ul>

    <div className="card__links">
      {project.links.map((link) => {
        const Icon = linkIcon[link.kind] || External
        const external = link.href.startsWith('http')
        return (
          <a
            className="card__link"
            key={link.href}
            href={link.href}
            {...(external
              ? { target: '_blank', rel: 'noreferrer noopener' }
              : {})}
          >
            <Icon />
            {link.label}
            {external && <span className="visually-hidden"> (opens in a new tab)</span>}
          </a>
        )
      })}
    </div>
  </article>
)

export const Projects = ({ work = [], business }) => (
  <section className="section" id="work">
    <div className="container">
      <Reveal className="section-head">
        <div>
          <p className="eyebrow">Selected work</p>
          <h2 className="section-title">Things I have built and shipped.</h2>
          {business && (
            <p className="section-sub">
              Published under my business,{' '}
              <a href={business.href} target="_blank" rel="noreferrer noopener">
                {business.name}
                <span className="visually-hidden"> (opens in a new tab)</span>
              </a>
              .
            </p>
          )}
        </div>
        <p className="section-count">
          {String(work.length).padStart(2, '0')} projects
        </p>
      </Reveal>

      <div className="work-grid">
        {work.map((project, i) => (
          <Reveal key={project.id} delay={i * 70}>
            <ProjectCard project={project} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
)
